export default __webpack_public_path__ + "static/media/gs.7e7c8177.png";